import { render, staticRenderFns } from "./PhoneNumber.vue?vue&type=template&id=5c4f7979&scoped=true&"
import script from "./PhoneNumber.vue?vue&type=script&lang=ts&"
export * from "./PhoneNumber.vue?vue&type=script&lang=ts&"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5c4f7979",
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-ca-tester/mfe-ca-tester/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c4f7979')) {
      api.createRecord('5c4f7979', component.options)
    } else {
      api.reload('5c4f7979', component.options)
    }
    module.hot.accept("./PhoneNumber.vue?vue&type=template&id=5c4f7979&scoped=true&", function () {
      api.rerender('5c4f7979', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/utils/PhoneNumber.vue"
export default component.exports